module.exports = __webpack_public_path__ + "img/12.313d6ae2.jpg";